<div class="chat-panel" [class.chat-panel--open]="open" *ngIf="open">

  <!-- Encabezado -->
  <header class="chat-panel__header">
    <div class="chat-panel__header-icon">
      <i class="fas fa-sparkles"></i>
    </div>
    <div class="chat-panel__header-text">
      <p class="chat-panel__title">Asistente Sismat</p>
      <p class="chat-panel__subtitle">Obtené ayuda en tus cómputos, consultá costos, materiales e índices</p>
    </div>
    <button class="chat-panel__close" type="button" aria-label="Cerrar" (click)="close()">
      <i class="fas fa-times"></i>
    </button>
  </header>

  <!-- Conversación -->
  <div class="chat-panel__body" #scrollArea>

    <!-- Estado inicial: sugerencias tomadas de consultas reales -->
    <div class="chat-panel__empty" *ngIf="isEmpty">
      <p class="chat-panel__empty-title">¿En qué te ayudo?</p>
      <p class="chat-panel__empty-text">
        Puedo ayudarte con tus cómputos, consultar precios de tareas y materiales, el detalle de una receta
        o darte soporte ante algun error en el sistema.
      </p>
      <button
        class="chat-panel__starter"
        type="button"
        *ngFor="let starter of starters"
        (click)="useStarter(starter)"
      >
        {{ starter }}
      </button>
    </div>

    <!-- Burbujas -->
    <div
      class="chat-panel__message"
      [ngClass]="'chat-panel__message--' + message.role"
      *ngFor="let message of messages; let i = index; trackBy: trackByIndex"
    >
      <div
        class="chat-panel__bubble"
        [class.chat-panel__bubble--error]="message.error"
      >
        <!-- Escribiendo -->
        <span class="chat-panel__typing" *ngIf="message.pending">
          <span></span><span></span><span></span>
        </span>

        <p class="chat-panel__text" *ngIf="!message.pending">{{ message.content }}</p>

        <ng-container *ngFor="let action of message.actions">

          <!-- Repregunta: se elige con un clic en vez de tipear -->
          <div
            class="chat-panel__options"
            *ngIf="asAskOptions(action) as ask"
          >
            <p class="chat-panel__options-question" *ngIf="ask.question">
              {{ ask.question }}
            </p>

            <button
              class="chat-panel__option"
              type="button"
              *ngFor="let option of ask.options"
              [disabled]="isAnswered(i) || loading"
              (click)="chooseOption(i, option)"
            >
              <span class="chat-panel__option-label">{{ option.label }}</span>
              <span class="chat-panel__option-hint" *ngIf="option.hint">{{ option.hint }}</span>
            </button>

            <p class="chat-panel__option-free" *ngIf="ask.allow_free_text && !isAnswered(i)">
              O escribí tu respuesta abajo.
            </p>
          </div>

          <!-- Propuesta de tareas: requiere confirmación explícita -->
          <div
            class="chat-panel__action"
            *ngIf="asAddTasks(action) as add"
          >
            <ng-container *ngIf="add.tasks.length">
              <p class="chat-panel__action-title">
                <i class="fas fa-list-check"></i>
                Tareas para agregar al cómputo
              </p>

              <ul class="chat-panel__action-list">
                <li *ngFor="let task of add.tasks">
                  <span class="chat-panel__action-name">{{ task.tarea }}</span>
                  <span class="chat-panel__action-qty" *ngIf="task.quantity !== null">
                    {{ task.quantity }} {{ task.unidad }}
                  </span>
                  <span class="chat-panel__action-qty" *ngIf="task.quantity === null">
                    sin cantidad
                  </span>
                </li>
              </ul>

              <button
                class="button is-small chat-panel__action-btn"
                type="button"
                *ngIf="!isApplied(i, add)"
                (click)="confirmAction(i, add)"
              >
                Agregar al cómputo
              </button>

              <p class="chat-panel__action-done" *ngIf="isApplied(i, add)">
                <i class="fas fa-check"></i> Agregado al cómputo
              </p>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Aviso de límite -->
  <div class="chat-panel__limit" *ngIf="limitReached">
    <i class="fas fa-circle-info"></i>
    {{ limitMessage }}
  </div>

  <!-- Entrada -->
  <form class="chat-panel__composer" (ngSubmit)="send()">
    <textarea
      class="chat-panel__input"
      [(ngModel)]="draft"
      name="draft"
      rows="1"
      [maxlength]="maxLength"
      [disabled]="limitReached"
      placeholder="Escribí tu consulta…"
      (keydown.enter)="$event.preventDefault(); send()"
    ></textarea>

    <button
      class="chat-panel__send"
      type="submit"
      [disabled]="!canSend"
      aria-label="Enviar"
    >
      <i class="fas" [ngClass]="loading ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
    </button>
  </form>

  <p class="chat-panel__footer" *ngIf="usage">
    Te quedan {{ usage.remaining_today }} consultas hoy · Costos de referencia Sismat
  </p>
</div>
